import {
  Button,
  TextField,
  Box,
  Typography,
  CircularProgress,
} from '@mui/material'
import PageAppBar from 'components/PageAppBar'
import { base_url } from 'env'
import { useState, useEffect } from 'react'
import { useLoaderData, useNavigate } from 'react-router-dom'
import axios from 'axios'

interface Milestone {
  id: string
  value: number
  title: string
}

export default function MilestoneEditPage() {
  const navigate = useNavigate()
  const initialData = useLoaderData() as Milestone
  const [milestone, setMilestone] = useState(initialData)
  const [isSaving, setIsSaving] = useState(false)

  useEffect(() => {
    setMilestone(initialData)
  }, [initialData])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target
    setMilestone((prev) => ({
      ...prev,
      [name]: name === 'value' ? Number(value) : value,
    }))
  }

  const handleSubmit = () => {
    if (!milestone.title || milestone.value < 0) {
      alert('Veuillez remplir tous les champs correctement.')
      return
    }

    setIsSaving(true)
    const token = localStorage.getItem('token')
    const { id, ...payload } = milestone // Exclude ID from the PUT payload

    axios
      .put(`${base_url}/milestone/${id}`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(() => {
        alert('Jalon mis à jour avec succès !')
        navigate('/milestones')
      })
      .catch((error) => {
        console.error('Failed to update milestone:', error)
        alert('La mise à jour a échoué: ' + error.response?.data?.message)
      })
      .finally(() => {
        setIsSaving(false)
      })
  }

  return (
    <PageAppBar pageName={`Modifier le Jalon: ${initialData.title}`}>
      <Box
        component="form"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '1rem',
          alignItems: 'center',
          padding: '2rem',
          maxWidth: '600px',
          margin: '0 auto',
        }}
      >
        <Typography variant="h5">Modifier le Jalon</Typography>
        <TextField
          required
          fullWidth
          name="title"
          label="Titre à décerner"
          value={milestone.title}
          onChange={handleChange}
        />
        <TextField
          required
          fullWidth
          name="value"
          label="Seuil (Points ou Temps total)"
          type="number"
          value={milestone.value}
          onChange={handleChange}
          inputProps={{
            min: 0,
          }}
        />
        <Button
          variant="contained"
          color="success"
          onClick={handleSubmit}
          disabled={isSaving}
          sx={{ mt: 2 }}
        >
          {isSaving ? <CircularProgress size={24} /> : 'Sauvegarder'}
        </Button>
      </Box>
    </PageAppBar>
  )
}
